export default "__VITE_ASSET__BsVPZYjT__"